import React, { PureComponent } from "react";

import { TTP_API_URL } from "Config";
import styles from "./Topic.local.scss";
import classnames from "classnames";
import { getDateLabel, getUserNameForAvatar } from "Utils";
import _ from "i18n";

export default class TopicComponent extends PureComponent {
  render() {
    const { topic, openTopicReveal } = this.props;

    const {
      category,
      language,
      organization,
      title,
      countComments,
      createdAt,
      user
    } = topic;

    const { firstName, lastName, avatar, avatarUrl } = user;

    let nameAttr = "nameFr";

    if (language) {
      nameAttr = `name${language.charAt(0).toUpperCase() + language.slice(1)}`;
    }

    return (
      <div className={styles.topic} onClick={openTopicReveal}>
        {avatarUrl || avatar ? (
          <div
            className={styles.author}
            style={{
              backgroundImage: `url(${
                avatarUrl ? avatarUrl : TTP_API_URL + "/" + avatar
              })`,
              borderColor: category.colorCode
            }}
          />
        ) : (
          <div className={classnames(styles.authorAvatar, "empty-avatar")}>
            <span>{getUserNameForAvatar(firstName, lastName)}</span>
          </div>
        )}
        <div className={styles.content}>
          <div
            className={classnames(
              styles.userInfos,
              user.function ? "grid-x" : ""
            )}
          >
            <div
              className={classnames(
                styles.userName,
                user.function ? "cell small-6" : ""
              )}
              style={
                !user.function
                  ? { textAlign: "center", padding: 0, display: "block" }
                  : null
              }
            >
              {firstName} {lastName}
            </div>
            {user.function ? (
              <div className={classnames(styles.userFunction, "cell small-6")}>
                {user.function}
              </div>
            ) : null}
          </div>
          {!organization ? null : (
            <h4>
              {organization.abbreviation
                ? organization.abbreviation
                : organization.name}
            </h4>
          )}
          <span
            className={styles.category}
            style={{ backgroundColor: category.colorCode }}
          >
            {category[nameAttr]}
          </span>
          <h3>{title}</h3>
          <div className={styles.footer}>
            <div className={styles.social}>
              <i className="icon icon-bubble" />
              <span className={styles.comment}>
                {countComments} {_("comments")}
              </span>
            </div>
            <div className={styles.date}>{getDateLabel(createdAt)}</div>
          </div>
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Topic/TopicComponent.js